import { Component, OnInit, ViewChild, Output } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpEventType,
  HttpParams,
} from "@angular/common/http";
import { Observable, Subject, merge, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  debounce,
} from "rxjs/operators";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
} from "@angular/forms";
import { catchError } from "rxjs/operators";
import { Router, Data, ActivatedRoute } from "@angular/router";
import { DatePipe, DecimalPipe } from "@angular/common";
import { SWAlertService } from "../../services/swalert.service";
import { BusinessDayService } from "../../services/business-day.service";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker/public_api";
import { promise } from "protractor";
import { isNullOrUndefined, log } from "util";
import { TSFuntionService } from "../../services/ts-funtion.service";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/ngx-bootstrap-typeahead";
import Swal from "sweetalert2";
import { async } from "rxjs/internal/scheduler/async";
import * as XLSX from "xlsx";
declare var Uploadfiles,
  Clearuploadfile,
  SetData,
  _Path,
  Extension: any,
  Accept: any;
declare var ArrFile: any[];
@Component({
  selector: "app-journalvoucher",
  templateUrl: "./journalvoucher.component.html",
  styleUrls: ["./journalvoucher.component.css"],
  providers: [DatePipe, TSFuntionService, DecimalPipe],
})
export class JournalVoucherComponent implements OnInit {
  isUseIo: boolean = false;
  isUseGL: boolean = false;
  EditInvoiceCode: any;
  EditInvoiceDate: any;
  ResultPermission: boolean;
  //NoResults
  TypeNoResult: any;
  CopyNoResult: any;
  GlNoResult: any[] = [];
  CostCenterNoResult: any[] = [];
  IONoResult: any[] = [];
  ProfitCenterNoResult: any[] = [];
  Approve1NoResult: any;
  Approve2NoResult: any;
  //
  clicked: boolean = false;
  isReject: boolean = false;
  IsNotFill_IO = false;
  IsNotFill_GL = false;
  isDraft: boolean = false;
  isNew: boolean = true;
  isSubmit: boolean = false;
  sReqID: any;
  sReqCode: any;
  haveRequestCode: boolean = false;
  haveComments: boolean = true;
  isNewRequest: boolean = false;
  isForROS: boolean = false;
  sComment: string = "";
  sCommentSSC: string = "";
  ArrTransactionHistory: Array<any> = [];
  nEditindex: any;
  isEdit: boolean;
  isPrint: boolean = false;
  isEditFromhome: boolean = false;
  isThai: boolean;
  bg_color: string = "";
  IsVendorOneTime: boolean = false;
  myFiles: string[] = [];
  sMsg: string = "";
  name: string;
  vendorcode: string;
  sGL: string;
  hVatAmount: boolean;
  nComcode: any;
  nCostCenterCode: any;
  sCostcen: any;
  ArrInvoice: Array<any> = [];
  ArrInvoicelength: any;
  ArrMaster: Array<any> = [];
  DataEmployee: any;
  DataRequest: any;
  DataGL: any;
  DataCostCenter: any;
  DataIO: any;
  DataProfitCenter: any;
  DataApprover: any;
  DataBusinessArea: any;
  ArrEmployee: any[] = [];
  ArrRequest: any[] = [];
  ArrIO: any[] = [];
  sArrGL: any[] = [];
  ArrCostCenter: any[] = [];
  ArrProfitCenter: any[] = [];
  ArrApprover: any[] = [];
  GetApprover: any;

  Currency: any;
  Currencys: any;
  totalDr: any;
  totalCr: any;
  today: number = Date.now();
  dToday = this.datepipe.transform(this.today, "dd/MM/yyyy");
  maxDate: Date;
  maxDateinvoice: any;
  TODAY: Date;
  toDay: Date;
  Settodate: Date;
  todayy: any;
  holidays: Date[]; //ตัวแปรรับค่า holiday
  _HolidayDB = [];
  bsConfig: Partial<BsDatepickerConfig>; //Set congic datepicker เท่านั้น ส่วน daterangpicker จะใช้อีก confic หนึ่ง
  JVForm: FormGroup;
  fileType: any;
  limit: any;

  fileName = "";
  fileDetail: File;
  fileExcel: any;
  ExcelData: any;
  isDisableImport = true;
  arrExcel: any[] = [];

  get _JVForm() {
    return this.JVForm.controls;
  }
  get ArrGL() {
    return this._JVForm.ArrGL as FormArray;
  } //Dynamic

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private SW: SWAlertService,
    private BusinessDay: BusinessDayService,
    private _decimalPipe: DecimalPipe,
    private System: TSFuntionService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  async ngOnInit() {
    this.System.BlockUI();
    let ua = this.System.GetUserStorage();
    this.nComcode = ua.sCompCode;
    this.ArrMaster[0] = [];

    this.isEdit = false;
    this.maxDate = new Date();
    this.maxDateinvoice = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 1);
    this.TODAY = new Date();
    this.toDay = new Date();
    this.totalDr = "0.00";
    this.totalCr = "0.00";
    this.SetForm();
    await this.http
      .get<any>("api/Autocomplete/TM_Holiday/*")
      .toPromise()
      .then((res) => {
        if (res) {
          this._HolidayDB = res.filter(
            (f) => f.IsDelete == false && f.cActive == "Y"
          );
        }
        this.holidays = this._HolidayDB.map(({ dDate }) => new Date(dDate));
      });
    //confic datepicker
    this.bsConfig = Object.assign(
      {},
      {
        containerClass: "theme-dark-blue", //set theme
        dateInputFormat: "DD/MM/YYYY", //set Format
        showWeekNumbers: false,
        datesDisabled: this.holidays, //set holidays (type Date only)
        daysDisabled: [0, 6],
      }
    );

    this.today = this.BusinessDay.SetToday(this.holidays).getTime();
    this.dToday = this.datepipe.transform(this.today, "dd/MM/yyyy");
    this.Settodate = this.BusinessDay.SetToday(this.holidays);
    this.TODAY = this.BusinessDay.SetToday(this.holidays);
    this.TODAY.setDate(this.TODAY.getDate() + 1);
    this.TODAY = this.BusinessDay.SetNextDate(this.TODAY, this.holidays);
    this.JVForm.patchValue({ dPostingDate: this.TODAY });

    await this.GetAutocomplete();
    this.hVatAmount = false;
    this.checkUseIo();
    this.checkUseGL();
   
    this.JVForm.patchValue({ dPostingDate: this.TODAY });
    this.activatedRoute.queryParams.subscribe(async (params) => {
      let ID: string = this.System.GetQuerySTR("str");
      let ID2: string = this.System.GetQuerySTR("ros");
      this.sReqID = await this.System.Decrypt(ID);
      if (ID2 !== "undefined") {
        this.sReqID = await this.System.Decrypt(ID2);
        this.isForROS = true;
      }
      if (this.sReqID === "") {
        this.isNewRequest = true;
      }
      this.Edit(this.sReqID);
    });
    await this.getFileType();
    await this.getFileLimit();
    var setUp = {
      sID: "dvFile",
      nFileSize: 15,
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true,
      ArrFile: ArrFile,
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limit,
    };
    Uploadfiles(setUp);
    Clearuploadfile();
  }

  async importFile(event) {
    let _this = this;
    const target: DataTransfer = <DataTransfer>event.target;
    this.fileName = target.files[0].name;
    this.fileDetail = target.files[0];
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const workbook = XLSX.read(bstr, { type: "binary" });
      this.ExcelData = XLSX.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[0]],
        { raw: false, rawNumbers: true }
      );
    };
    reader.readAsBinaryString(this.fileDetail);
    event.target.value = ''

    var formData = new FormData();
    formData.append('file', this.fileDetail);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'api/_Paytovendor/UploadExcel'); // Replace with your controller and action method names
    xhr.onload = function() {
    
    };
    xhr.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
          var response = xhr.response;
          const responseJson = JSON.parse(response);
          if (response) {
            _this.fileExcel = {
              nID: 1,
              sPath: responseJson.SaveToPath,
              sSystemFileName: responseJson.SaveToFileName,
              sFileName: responseJson.FileName,
              IsDelete: false,
              IsNew: true,
              sSize: _this.fileDetail.size,
            }
          }
      };
    }
    xhr.send(formData);
    
  }
  checkHaveFileUpload() {
    this.isDisableImport = this.ExcelData === undefined;
    return "";
  }

  async readFile() {
    this.System.BlockUI();
    this.ArrGL.clear();
    this.arrExcel = [];
    let _this = this;
    if (this.ExcelData.length > 0) {
      const result = [];
      const resultExcel = [];
      let checkRequireField = false;
      let errorRequireField = '';
      for (let x = 0; x < this.ExcelData.length; x++) {
        let itemExcel = {
          sNo: null,
          sType: null,
          sCustomerNickname: null,
          sPostingDate: null,
          sGL1: null,
          sGLName1: null,
          sGL2: null,
          sGLName2: null,
          sAmount: null,
          sProfitCenter: null,
          sCostCenter: null,
          sIO: null,
          sText: null,
          sTradingPartner: null,
        };

        let item1 = {
          sVendorName: null,
          sGL: null,
          sCostCenter: null,
          sIO: null,
          sProfitCenter: null,
          sAmountExcludedVAT: null,
          sText: null,
          sInvoiceNo: null,
          nLine: null,
          nReceiveType: null,
          dCreateDate: null,
        };

        let item2 = {
          sVendorName: null,
          sGL: null,
          sCostCenter: null,
          sIO: null,
          sProfitCenter: null,
          sAmountExcludedVAT: null,
          sText: null,
          sInvoiceNo: null,
          nLine: null,
          nReceiveType: null,
          dCreateDate: null,
        };

        if (this.ExcelData[x]["No."]) itemExcel.sNo = this.ExcelData[x]["No."];
        if (this.ExcelData[x]["Revenue\r\n/Expense"]) {
          itemExcel.sType = this.ExcelData[x]["Revenue\r\n/Expense"];
        } else {
        }
        if (this.ExcelData[x]["Vendor/Customer"]) {
          itemExcel.sCustomerNickname = this.ExcelData[x]["Vendor/Customer"];
        } else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Description"]) {
          itemExcel.sText = this.ExcelData[x]["Description"];
        } else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Transaction Date"]) {
          itemExcel.sPostingDate = this.dateFormat(
            this.ExcelData[x]["Transaction Date"]
          );
        } else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["Amount (Ex.vat)"]) {
          itemExcel.sAmount = this.ExcelData[x]["Amount (Ex.vat)"];
        } else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["GL Revenue\r\n/GL Expense"]) {
          if (this.ExcelData[x]["GL Revenue\r\n/GL Expense"].length > 10) {
            checkRequireField = true;
            errorRequireField = 'GL Revenue/GL Expense must not exceed 10 characters';
            break;
          }
          else {
            itemExcel.sGL1 = this.ExcelData[x]["GL Revenue\r\n/GL Expense"];
          }
        } else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["GL Revenue Name\r\n/GL Expense Name"])
          itemExcel.sGLName1 =
            this.ExcelData[x]["GL Revenue Name\r\n/GL Expense Name"];
        if (this.ExcelData[x]["GL Accrue"]) {
          if (this.ExcelData[x]["GL Accrue"].length > 10) {
            checkRequireField = true;
            errorRequireField = 'GL Accrue must not exceed 10 characters';
            break;
          }
          else {
          itemExcel.sGL2 = this.ExcelData[x]["GL Accrue"];
          }
        } else {
          checkRequireField = true;
          break;
        }
        if (this.ExcelData[x]["GL Accrue Name"])
          itemExcel.sGLName2 = this.ExcelData[x]["GL Accrue Name"];
        if (this.ExcelData[x]["Profit Center)"]) {
          if (this.ExcelData[x]["Profit Center"].length > 20) {
            checkRequireField = true;
            errorRequireField = 'Profit Center must not exceed 20 characters';
            break;
          }
          else {
            itemExcel.sProfitCenter = this.ExcelData[x]["Profit Center"];
          }
        }
        if (this.ExcelData[x]["Cost Center"]) {
          if (this.ExcelData[x]["Cost Center"].length > 10) {
            checkRequireField = true;
            errorRequireField = 'Cost Center must not exceed 10 characters';
            break;
          }
          else {
            itemExcel.sCostCenter = this.ExcelData[x]["Cost Center"];
          }
        }
        if (this.ExcelData[x]["Internal Order"]) {
          if (this.ExcelData[x]["Internal Order"].length > 20) {
            checkRequireField = true;
            errorRequireField = 'Internal Order must not exceed 20 characters';
            break;
          }
          else {
            itemExcel.sIO = this.ExcelData[x]["Internal Order"];
          }
        }
        if (this.ExcelData[x]["Trading Partner"])
          itemExcel.sTradingPartner = this.ExcelData[x]["Trading Partner"];

        item1.sVendorName = itemExcel.sCustomerNickname;
        item1.sGL = itemExcel.sGL1;
        item1.sCostCenter = itemExcel.sCostCenter;
        item1.sIO = itemExcel.sIO;
        item1.sProfitCenter = itemExcel.sProfitCenter;
        item1.sAmountExcludedVAT = itemExcel.sAmount;
        item1.sText = itemExcel.sText;
        item1.sInvoiceNo = (x + 1).toString();
        item1.nLine = 1;
        item1.nReceiveType = 1;
        item1.dCreateDate = itemExcel.sPostingDate;

        item2.sVendorName = itemExcel.sCustomerNickname;
        item2.sGL = itemExcel.sGL2;
        item2.sCostCenter = itemExcel.sCostCenter;
        item2.sIO = itemExcel.sIO;
        item2.sProfitCenter = itemExcel.sProfitCenter;
        item2.sAmountExcludedVAT = itemExcel.sAmount;
        item2.sText = itemExcel.sText;
        item2.sInvoiceNo = (x + 1).toString();
        item2.nLine = 2;
        item2.nReceiveType = 2;
        item2.dCreateDate = itemExcel.sPostingDate;

        result.push(item1);
        result.push(item2);
        resultExcel.push(itemExcel);
      }
      if (checkRequireField) {
        _this.SW.SwAlert.Error(
          _this.SW.BoxMsg.Title_Error,
          errorRequireField != ''? errorRequireField : _this.SW.BoxMsg.Desc_Specify_Require,
          undefined
        );
      } else {
        result.forEach((item) => {
          this.ArrGL.push(
            new FormGroup({
              sVendorName: new FormControl(item.sVendorName),
              sGL: new FormControl(item.sGL),
              sCostCenter: new FormControl(item.sCostCenter),
              sIO: new FormControl(item.sIO),
              sProfitCenter: new FormControl(item.sProfitCenter),
              sAmountExcludedVAT: new FormControl(item.sAmountExcludedVAT),
              sText: new FormControl(item.sText),
              IsDelete: new FormControl(false),
              sInvoiceNo: new FormControl(item.sInvoiceNo),
              nline: new FormControl(item.nLine),
              nReceiveType: new FormControl(item.nReceiveType.toString()),
              dCreateDate: new FormControl(item.dCreateDate),
            })
          );
        });
        resultExcel.forEach((item) => {
          this.arrExcel.push(item);
        });
      }
    }
    this.System.UnBlockUI();
  }

  dateFormat(dateData) {
    const date = new Date((dateData - 25569) * 86400 * 1000);
    let result = null;
    if (isNaN(date.getDate())) {
      result = new Date(dateData);
    } else {
      result =
        date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    }
    return result;
  }

  checkFile() {
    if (ArrFile.filter((f) => f.IsDelete === false).length > 0) {
      const chkFile = document.getElementById("dv_dvFile");
      chkFile.style.border = "1px solid #dde4f6";
    }
    return "";
  }
  async Reject() {
    let _this = this;
    let sComment = _this.JVForm.get("sComment").value;
    if (sComment === null || sComment === "") {
      _this.SW.SwAlert.Error(
        _this.SW.BoxMsg.Title_Error,
        _this.SW.BoxMsg.Desc_Specify_Comment,
        undefined
      );
    } else {
      let DataSave = {
        TRequest: {
          sRequestID: _this.JVForm.get("sRequestID").value,
          sComment: sComment,
        },
      };
      let Data = JSON.stringify(DataSave);
      let save = function () {
        _this.System.BlockUI();
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
        });
        _this.http
          .post(_this.System.SiteName + "api/ROService/Reject", Data, {
            headers,
            responseType: "text",
          })
          .subscribe((s) => {
            if (s == "Success") {
              ArrFile = [];
              _this.System.UnBlockUI();
              _this.SW.SwAlert.Success(
                _this.SW.BoxMsg.Title_Success,
                _this.SW.BoxMsg.Desc_SaveComplete,
                function () {
                  _this.router.navigate(["ro-service"]);
                }
              );
            } else {
              _this.System.UnBlockUI();
            }
          });
      };
      _this.SW.SwAlert.Confirm(
        _this.SW.BoxMsg.Title_Confirm,
        _this.SW.BoxMsg.Desc_Confirm_Submit,
        save,
        function () {}
      );
    }
  }
  async getFileType() {
    await this.http
      .get(this.System.SiteName + "api/FileConfig/FileType")
      .toPromise()
      .then((data: Response) => {
        const result = [];
        const item = Object.values(data);
        for (let x = 0; x < item.length; x++) {
          if (data[x]["sValue"] === "Y") {
            result.push(data[x]["sValueText"]);
          }
        }
        this.fileType = result;
      });
  }
  async getFileLimit() {
    await this.http
      .get(this.System.SiteName + "api/FileConfig/FileLimit")
      .toPromise()
      .then((data: Response) => {
        const result = [];
        const item = Object.values(data);
        for (let x = 0; x < item.length; x++) {
          result.push(data[x]["sValue"]);
        }
        this.limit = result;
      });
  }
  handler(select): void {
    if (select == 1) {
      let dPostingDate = this.JVForm.value.dPostingDate; //get value dDue formControlName
    
      this.JVForm.patchValue({ dPostingDate: dPostingDate });
    }
    if (select == 2) {
      let Invoicedate = this.JVForm.value.dInvoiceDate;
      this.JVForm.patchValue({ dInvoiceDate: Invoicedate });
    }
  }
  //#region "GetAutocomplete"
  async GetAutocomplete() {
    this.http
      .get(
        this.System.SiteName +
          "api/Autocomplete/TUserpermission/*/sCompCode/" +
          this.nComcode +
          "/nRole/5"
      )
      .subscribe((data: Response) => {
        this.DataEmployee = data;
        this.ArrEmployee = this.DataEmployee.map(
          (data) => data.sName + " " + data.sSurName
        );
      });

    //AutocompleteTRequest
    this.ArrRequest = [];
    this.http
      .get(
        this.System.SiteName +
          "api/_Paytovendor/GetCopyJV/" +
          this.nComcode +
          ""
      )
      .subscribe((data: Response) => {
        this.DataRequest = data;
        if (this.DataRequest != null) {
          this.ArrRequest = this.DataRequest.map((re) => re.sRequestCode);
        }
      });

    const httpOptions_GL = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sCompCode", this.nComcode),
    };
    //AutocompleteGL
    await this.http
      .get(this.System.SiteName + "api/_System/GetGL", httpOptions_GL)
      .toPromise()
      .then((data: Response) => {
        this.DataGL = data;
        this.sArrGL = this.DataGL;
      });

    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sCompCode", this.nComcode),
    };
    //AutocompleteCOSTCENTER
    this.http
      .get(
        this.System.SiteName + "api/_System/GetCostCenter",
        httpOptions_CostCenter
      )
      .subscribe((data: Response) => {
        this.DataCostCenter = data;
        this.ArrCostCenter = this.DataCostCenter;
      });

    const httpOptions_IO = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sCompCode", this.nComcode),
    };
    //AutocompleteIO
    await this.http
      .get(this.System.SiteName + "api/_System/GetIO2", httpOptions_IO)
      .toPromise()
      .then((data: Response) => {
        this.DataIO = data;
        if (this.DataIO != null) {
          this.ArrIO = this.DataIO;
          this.ArrMaster[0] = this.ArrIO;
        }
      });

    const httpOptions_ProfitCenter = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sCompCode", this.nComcode),
    };
    //AutocompleteProfitCenter
    await this.http
      .get(
        this.System.SiteName + "api/_System/GetProfitCenter",
        httpOptions_ProfitCenter
      )
      .toPromise()
      .then((data: Response) => {
        if (data != null) {
          this.DataProfitCenter = data;
          this.ArrProfitCenter = this.DataProfitCenter;
        }
      });

    //AutocompleteApprover
    await this.http
      .get(
        this.System.SiteName +
          "api/_Paytovendor/GetApproverAll/" +
          this.nComcode +
          ""
      )
      .toPromise()
      .then((data: Response) => {
        if (data) {
          this.DataApprover = data;
        } else {
          this.DataApprover = [];
        }

        this.ArrApprover[0] = [];
        this.ArrApprover[1] = [];

        //GetApprover
        this.http
          .get(
            this.System.SiteName +
              "api/_Paytovendor/GetApprover/" +
              this.nComcode +
              "/80"
          )
          .toPromise()
          .then((data: Response) => {
            if (data) {
              this.GetApprover = data[0];
            } else {
              this.GetApprover = null;
            }
            if (this.GetApprover != null) {
              if (this.GetApprover.cActive == "Y") {
                this.ArrApprover[0] = this.DataApprover.filter(
                  (f) => f.nRole == 3
                );
                this.ArrApprover[1] = this.DataApprover.filter(
                  (f) => f.nRole == 4
                );
                if (this.GetApprover.IsApprover_1 == false) {
                  this.JVForm.controls["ddApprover1"].disable();
                  this.JVForm.controls["cSkipApprove1"].setValue(true);
                } else {
                  this.JVForm.controls["ddApprover1"].enable();
                  let name1 = this.DataApprover.filter(
                    (f) => f.nUserID == this.GetApprover.name1ID
                  )[0];
                  let nUserId = this.DataApprover.filter(
                    (f) => f.nUserID == this.GetApprover.name1ID
                  )[0];
                  this.JVForm.patchValue({
                    ddApprover1:
                      isNullOrUndefined(name1) == true ? "" : name1.name1,
                    sApprove1:
                      isNullOrUndefined(nUserId) == true
                        ? null
                        : nUserId.nUserID,
                  });
                }
                if (this.GetApprover.IsApprover_2 == false) {
                  this.JVForm.controls["ddApprover2"].enable();
                } else {
                  this.JVForm.controls["ddApprover2"].enable();

                  let name1 = this.DataApprover.filter(
                    (f) => f.nUserID == this.GetApprover.name2ID
                  )[0];
                  let nUserId = this.DataApprover.filter(
                    (f) => f.nUserID == this.GetApprover.name2ID
                  )[0];
                  this.JVForm.patchValue({
                    ddApprover2:
                      isNullOrUndefined(name1) == true ? "" : name1.name1,
                    sApprove2:
                      isNullOrUndefined(nUserId) == true
                        ? null
                        : nUserId.nUserID,
                  });
                }
              } else if (this.GetApprover.cActive == "N") {
                this.ArrApprover[0] = this.DataApprover.filter(
                  (f) => f.nRole == 3
                );
                this.ArrApprover[1] = this.DataApprover.filter(
                  (f) => f.nRole == 4
                );
              }
            }
          });
      });

    //DropdownCurrency
    this.http
      .get(this.System.SiteName + "api/Autocomplete/MT_CURRENCY/*")
      .subscribe((data: Response) => {
        this.Currency = data;
      });

    //DropdownBusinessAreas
    this.http
      .get<any>(this.System.SiteName + "api/Autocomplete/MT_BUSINESS_AREA/*")
      .subscribe((data) => {
        if (data != null) {
          this.DataBusinessArea = data;
          this.JVForm.patchValue({
            sBusinessArea: this.DataBusinessArea.filter(
              (f) => f.CompCode == this.nComcode
            )[0].BUSINESS_AREA,
          });
        }
      });
  }
  //#endregion
  onUserSelect(sName) {
    let lstData = this.DataEmployee.filter(
      (user) => user.sName + " " + user.sSurName == sName
    )[0];
    if (lstData != undefined) {
      this.nComcode = lstData.sCompCode;
      this.JVForm.patchValue({
        nContactID: lstData.sEmpCode,
        sName: lstData.sName + " " + lstData.sSurName,
        sEmail: lstData.sEmail,
        sUnit: lstData.sUnit,
        sTel: lstData.sTel,
      });
    } else {
    }
  }
  async onCopyRequestCodeSelect(RequestCode) {
    if (RequestCode != "") {
      let Data: any;
      let lstData = this.DataRequest.filter(
        (user) => user.sRequestCode == RequestCode
      )[0];
      await this.http
        .get(
          this.System.SiteName +
            "api/_paytovendor/GetRequest/" +
            lstData.sRequestID +
            ""
        )
        .toPromise()
        .then((data: any) => {
          Data = data.filter((f) => f.cActive != "N");
        });

      if (Data == null || Data.length === 0) return;
        this.ArrInvoice = Data;

        let totalDr = 0;
        let totalCr = 0;
        this.ArrGL.clear();
        this._JVForm.ArrGL.reset();
        this.JVForm.patchValue({
          nCopyRequest: Data[0].sRequestID,
          sOtherRefNoFIDocNo: Data[0].sOtherRefNoFIDocNo,
          sDescription: Data[0].sDescription,
          ddApprover1: Data[0].sUserApprove1,
          ddApprover2: Data[0].sUserApprove2,
          sApprove1: Data[0].nApprove1 == null ? null : Data[0].nApprove1,
          sApprove2: Data[0].nApprove2 == null ? null : Data[0].nApprove2,
          cSkipApprove1: Data[0].cSkipApprove1 == "Y" ? true : false,
        });
        for (let i = 0; i < this.ArrInvoice.length; i++) {
          this.ArrGL.push(
            new FormGroup({
              sGL: new FormControl(Data[i].sGL, Validators.required),
              sCostCenter: new FormControl(Data[i].sCostCenter),
              sIO: new FormControl(Data[i].sIO),
              sProfitCenter: new FormControl(Data[i].sProfitCenter),
              sAmountExcludedVAT: new FormControl(
                Data[i].sAmount.toFixed(2),
                Validators.required
              ),
              sText: new FormControl(Data[i].sText, Validators.required),
              IsDelete: new FormControl(Data[i].IsDelete),
              sInvoiceNo: new FormControl(""),
              nline: new FormControl(Data[i].nLine),
              nReceiveType: new FormControl(Data[i].nReceiveType.toString()),
            })
          );
          if (!Data[i].IsDelete) {
            if (Data[i].nReceiveType === 1) {
              totalDr += Data[i].sAmount;
            } else {
              totalCr += Data[i].sAmount;
            }
          }
        }
        this.totalDr = this._ConvertToDecimal(totalDr);
        this.totalCr = this._ConvertToDecimal(totalCr);

      if (Data[0].cSkipApprove1 == "Y") {
        this.JVForm.get("ddApprover1").disable();
      } else {
        this.JVForm.get("ddApprover1").enable();
      }
    }
  }

  checkrange() {
    let _this = this;
    var st = this.JVForm.get("nVendorCode").value.length;
    if (st > 10) {
      let clear = function () {
        _this.JVForm.get("nVendorCode").setValue("");
      };
      this.SW.SwAlert.Error(
        _this.SW.BoxMsg.Title_Error,
        _this.SW.BoxMsg.DescOneVendorLength,
        clear
      );
    }
  }
  CommentChange(event) {
    this.JVForm.patchValue({
      sComment: event.target.value,
    });

    this.sComment = event.target.value == null ? "" : event.target.value;
  }
  CommentChangeSSC(event) {
    this.JVForm.patchValue({
      sCommentSSC: event.target.value,
    });

    this.sCommentSSC = event.target.value == null ? "" : event.target.value;
  }

  onGLSelect(row) {
    this.sGL = this.ArrGL.value.sGL;
  }
  async onCostCenterSelect(sCost, row) {
    let _this = this;
    if (sCost != undefined && sCost != "") {
      let lstData = this.DataCostCenter.filter(
        (s) => s.COST_CENTER == sCost
      )[0];
      let nCostCode = lstData.COST_CENTER;
      const httpOptions_IO = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
        params: new HttpParams().set("sCompCode", this.nComcode),
      };

      //AutocompleteIO
      await this.http
        .get(_this.System.SiteName + "api/_System/GetIO2", httpOptions_IO)
        .toPromise()
        .then((data: Response) => {
          this.DataIO = data;
          if (this.DataIO != null) {
            this.ArrMaster[row] = this.DataIO;
          } else {
            this.ArrMaster[row] = ["", ""];
          }
        });
    }
  }

  onApprover1(value) {
    let ckNull = this.JVForm.get("ddApprover1").value;
    let ischeck = this.ArrApprover[0].filter((f) => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.JVForm.patchValue({
        sApprove1: null,
      });
    } else if (this.Approve1NoResult == false && !isNullOrUndefined(ischeck)) {
      this.JVForm.patchValue({
        sApprove1: value.item.nUserID,
      });
    } else if (this.Approve1NoResult == false && isNullOrUndefined(ischeck)) {
      this.JVForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      });
    }
    if (this.Approve1NoResult == true) {
      this.JVForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      });
    }
  }
  onApprover2(value) {
    let ckNull = this.JVForm.get("ddApprover2").value;
    let ischeck = this.ArrApprover[1].filter((f) => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.JVForm.patchValue({
        sApprove2: null,
      });
    } else if (this.Approve2NoResult == false && !isNullOrUndefined(ischeck)) {
      this.JVForm.patchValue({
        sApprove2: value.item.nUserID,
      });
    } else if (this.Approve2NoResult == false && isNullOrUndefined(ischeck)) {
      this.JVForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      });
    }
    if (this.Approve2NoResult == true) {
      this.JVForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      });
    }
  }

  //***********Save*****************

  async Save(mode) {
    //#region CheckValidate
    let _this = this;
    let _FormGroup = this.JVForm;
    let IsValid: boolean = true;
    let FieldValid: string[] = [];
    if (mode != 3) {
      let arrGl = this.JVForm.value.ArrGL;
      if (mode == 1) {
        FieldValid = ["sName"];
      } else if (mode == 2) {
        FieldValid = ["ddApprover2", "ddApprover1", "sDescription"];
        if (arrGl.length == 0) {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Specify_JV, undefined)
          _this.clicked = false;
          return false;
        } else {
          let FromArray = this.ArrGL.value.filter((x) => x.IsDelete == false);
          let totalDr = 0;
          let totalCr = 0;
          for (let i = 0; i < FromArray.length; i++) {
            let value = 0;
            let str = FromArray[i].sAmountExcludedVAT;
            let type = FromArray[i].nReceiveType;
            if (str === "") {
              str = "0";
            } else if (str.substring(str.length - 1) === ".") {
              str = str.substring(0, str.length - 1);
            }
            value = parseFloat(str);
            if (type === "1") {
              totalDr += value;
            } else {
              totalCr += value;
            }
          }
          if (totalDr != totalCr) {
            this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_JV_TotalNoMatch, undefined)
            _this.clicked = false;
            return false;
          }
        }
        let FieldGLValid: string[] = ["sAmountExcludedVAT", "sText"];
        //if (this.isUseIo) {
        //  FieldGLValid.push("sIO");
        //}
        if (this.isUseGL) {
          FieldGLValid.push("sGL");
        }
        for (let i = 0; i < this.ArrGL.length; i++) {
          FieldGLValid.forEach(function (Field) {
            let FromArray = _FormGroup.get("ArrGL") as FormArray;
            if (!FromArray.at(i).get(Field).valid && mode != 1) {
              IsValid = false;
              _this.clicked = false;
              return false;
            }
          });
        }
        FieldValid.forEach(function (Field) {
          if (
            !_FormGroup.get(Field).valid &&
            _FormGroup.get(Field).disabled == false
          ) {
            IsValid = false;
          }
        });
      }
      if (IsValid) {
        let arrItem = [];
        let arrExcel = [];
        arrGl.forEach(function (value, i: number) {
          let arr = {
            nLine: _this.JVForm.get("IsUploadExcelFile").value
              ? value.nline
              : i + 1,
            sVendorName: value.sVendorName,
            sGL: value.sGL,
            sCostCenter: value.sCostCenter,
            sIO: value.sIO === "Not Require IO (N/A)" ? null : value.sIO,
            sProfitCenter: value.sProfitCenter,
            sAmount: _ParseFloatToZero(value.sAmountExcludedVAT),
            sText: value.sText,
            cVenderMaster: "M",
            IsDelete: value.IsDelete,
            nReceiveType: parseFloat(value.nReceiveType),
            sInvoiceNo: value.sInvoiceNo,
            dCreateDate: value.dCreateDate,
          };
          arrItem.push(arr);
        });
        _this.arrExcel.forEach(function (value, i: number) {
          let arr = {
            sNo: value.sNo,
            sType: value.sType,
            sCustomerNickname: value.sCustomerNickname,
            sPostingDate: _this.datepipe.transform(value.sPostingDate, "dd/MM/yyyy"),
            sGL1: value.sGL1,
            sGLName1: value.sGLName1,
            sGL2: value.sGL2,
            sGLName2: value.sGLName2,
            sAmount: value.sAmount,
            sProfitCenter: value.sProfitCenter,
            sCostCenter: value.sCostCenter,
            sIO: value.sIO,
            sText: value.sText,
            sTradingPartner: value.sTradingPartner,
          };
          arrExcel.push(arr);
        });
        let DataSave = {
          TRequest: {
            sRequestID: _this.JVForm.get("sRequestID").value,
            sCompCode: _this.nComcode,
            nReqType: _this.JVForm.get("ntype").value + "",
            nYear: _this.datepipe.transform(_this.today, "yyyy"),
            sRequestBy: _this.JVForm.get("sRequestBy").value + "",
            dRequestDate: _this.dToday,
            nContactID: Number(_this.JVForm.get("nContactID").value),
            sContactName: _this.JVForm.get("sName").value,
            dPostingDate: _this.datepipe.transform(
              _this.JVForm.get("dPostingDate").value,
              "dd/MM/yyyy"
            ),
            sDescription: _this.JVForm.get("sDescription").value,
            sOtherRefNoFIDocNo: _this.JVForm.get("sOtherRefNoFIDocNo").value,
            sUnitName: _this.JVForm.get("sUnit").value,
            sEmail: _this.JVForm.get("sEmail").value,
            sTel: _this.JVForm.get("sTel").value,
            nInvoiceType: "",
            sRefAdvanceNo: "",
            IsReqUrgent: false,
            IsSSCUrgent: false,
            IsVendorGroup: false,
            sCurrency: _this.JVForm.get("ddCurrency").value,
            nStatusID: mode == 1 ? 1 : 2,
            sCopyReqID: _this.JVForm.get("nCopyRequest").value,
            nStep: 1,
            nFlowNo: 1,
            sCreateBy: _this.JVForm.get("sRequestBy").value + "",
            sUpdateBy: _this.JVForm.get("sRequestBy").value + "",
            sDeleteBy: "",
            cSkipApprove1:
              _this.JVForm.get("cSkipApprove1").value == 1 ? "Y" : "N",
            nApprove1: _this.JVForm.get("sApprove1").value,
            cApprove1: "W",
            nApprove2: _this.JVForm.get("sApprove2").value,
            cApprove2: "W",
            cSkipApprove2: "N",
            sBusinessArea: _this.JVForm.get("sBusinessArea").value,
            nReqUrgentDay: 0,
            dStartDate: _this.Settodate,
            sComment: _this.JVForm.get("sComment").value,
            sCommentSSC: _this.JVForm.get("sCommentSSC").value,
            IsUploadExcelFile: _this.JVForm.get("IsUploadExcelFile").value,
          },
          TRequestItems: arrItem,
          TRequestExcel: arrExcel,
          FileUp: ArrFile,
          FileExcel: _this.fileExcel,
          CommentDelete: this.sComment,
        };
        let Data = JSON.stringify(DataSave);
        let saveDaft = function () {
          _this.System.BlockUI();
          _this.isEditFromhome = false;
          const headers = new HttpHeaders({
            "Content-Type": "application/json",
          });
          _this.http
            .post(_this.System.SiteName + "api/_Paytovendor/Save", Data, {
              headers,
              responseType: "text",
            })
            .subscribe((s) => {
              if (s == "Success") {
                ArrFile = [];
                _this.System.UnBlockUI();
                _this.SW.SwAlert.Success(
                  _this.SW.BoxMsg.Title_Success,
                  _this.SW.BoxMsg.Desc_SaveComplete,
                  function () {
                    _this.router.navigate(["home"]);
                  }
                );
              } else {
                _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, s, undefined)
                _this.System.UnBlockUI();
              }
            });
        };
        this.SW.SwAlert.Confirm(
          this.SW.BoxMsg.Title_Confirm,
          this.SW.BoxMsg.Desc_Confirm_Submit,
          saveDaft,
          function () {}
        );
      } else {
        FieldValid.forEach(function (Field) {
          const control = _FormGroup.get(Field);
          //{3}
          if (control instanceof FormControl && control.status != "DISABLED") {
            //{4}
            control.markAsTouched({ onlySelf: true });
          }
        });
      }
      if (this.ArrInvoice.filter((f) => f.cActive != "N").length == 0) {
        let FieldGLValid: string[] = ["sAmountExcludedVAT", "sText"];
        //if (this.isUseIo) {
        //  FieldGLValid.push("sIO");
        //}
        if (this.isUseGL) {
          FieldGLValid.push("sGL");
        }
        for (let i = 0; i < this.ArrGL.length; i++) {
          FieldGLValid.forEach(function (Field) {
            let FromArray = _FormGroup.get("ArrGL") as FormArray;
            const control = FromArray.at(i).get(Field); //{3}
            if (
              control instanceof FormControl &&
              mode != 1 &&
              control.status != "DISABLED"
            ) {
              //{4}
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
      }
    } else if (mode == 3) {
      //Recall
      let DataSave = {
        TRequest: {
          sRequestID: _this.JVForm.value.sRequestID,
          nStatusID: 3,
        },
      };
      let Data = JSON.stringify(DataSave);
      let SaveRecall = function () {
        _this.isEditFromhome = false;
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
        });
        _this.http
          .post(_this.System.SiteName + "api/_Paytovendor/Recall", Data, {
            headers,
            responseType: "text",
          })
          .subscribe((s) => {
            if (s == "Success") {
              _this.SW.SwAlert.Success(
                _this.SW.BoxMsg.Title_Success,
                _this.SW.BoxMsg.Desc_SaveComplete,
                function () {
                  _this.router.navigate(["home"]);
                }
              );
            }
          });
      };
      this.SW.SwAlert.Confirm(
        this.SW.BoxMsg.Title_Confirm,
        this.SW.BoxMsg.Desc_Confirm_Save,
        SaveRecall,
        function () {}
      );
    }
    _this.clicked = false;
  }
  cancel() {
    let _this = this;
    if (_this.sComment === null || _this.sComment === "") {
      this.SW.SwAlert.Error(
        this.SW.BoxMsg.Title_Error,
        this.SW.BoxMsg.Desc_Specify_Comment,
        undefined
      );
    } else {
      let DataSave = {
        TRequest: {
          sRequestID: _this.JVForm.value.sRequestID,
          nStatusID: 0,
        },
        CommentDelete: this.sComment,
      };
      let Data = JSON.stringify(DataSave);
      let SaveRecall = function () {
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
        });
        _this.http
          .post(_this.System.SiteName + "api/_Paytovendor/cancel", Data, {
            headers,
            responseType: "text",
          })
          .subscribe((s) => {
            if (s == "Success") {
              _this.SW.SwAlert.Success(
                _this.SW.BoxMsg.Title_Success,
                _this.SW.BoxMsg.Desc_Success_Delete,
                function () {
                  _this.router.navigate(["home"]);
                }
              );
            }
          });
      };
      this.SW.SwAlert.Confirm(
        this.SW.BoxMsg.Title_Confirm,
        this.SW.BoxMsg.Desc_Confirm_Delete,
        SaveRecall,
        function () {}
      );
    }
  }

  //***********EditFormHome*****************

  async Edit(sReqID) {
    let _this = this;
    this.System.BlockUI();
    let Isnull = sReqID == "" ? true : false;
    const ua = this.System.GetUserStorage();
    if (this.isForROS) Isnull = true;
    if (ua.IsROService && Isnull) {
      this.isReject = true;
    }
    if (!Isnull) {
      // เช็คว่า ใบใหม่หรือใบเก่า
      _this.JVForm.patchValue({ sRequestID: sReqID });
      _this.isDraft = true;
      _this.isPrint = true;
      _this.haveComments = true;
      await this.http
        .get(
          this.System.SiteName +
            "api/Autocomplete/TRequest/sRequestCode/sRequestID/" +
            sReqID +
            ""
        )
        .toPromise()
        .then((Data) => {
          if (Data) {
            if (
              !isNullOrUndefined(Data[0].sRequestCode) &&
              Data[0].sRequestCode != ""
            ) {
              _this.sReqCode = Data[0].sRequestCode;
              _this.haveRequestCode = true;
            }
          }
        });
      //await this.http.get(this.System.SiteName + "api/_Paytovendor/CheckReject/" + sReqID + "").toPromise().then(Data => {
      //  if (Data) {
      //    if (!isNullOrUndefined(Data[0].sComment) && Data[0].sComment != "") {
      //      _this.sComment = Data[0].sComment;
      //      _this.JVForm.patchValue({
      //        sComment: Data[0].sComment,
      //      })
      //    }
      //  }
      //})
      let _FormGroup = this.JVForm;
      this.ArrMaster = [];
      this.ArrMaster.push(this.ArrIO);
      this.ArrGL.clear();
      this._JVForm.ArrGL.reset();
      let data: any;
      let data2: any;
      await this.http
        .get(
          this.System.SiteName + "api/_Paytovendor/GetRequest/" + sReqID + ""
        )
        .toPromise()
        .then((Data) => (data = Data));
      _this.ArrInvoice = data;
      await this.http
        .get(
          this.System.SiteName +
            "api/_Paytovendor/GetTransactionHistory/" +
            sReqID +
            ""
        )
        .toPromise()
        .then((Data) => (data2 = Data));
      _this.ArrTransactionHistory = data2;
      let lstArrInvoice =
        _this.ArrInvoice != null
          ? _this.ArrInvoice.filter((f) => f.cActive != "N")
          : [];
      if (lstArrInvoice.length > 0) {
        // เช็คว่า มี invoice ไหม

        if (
          lstArrInvoice[0].nStatusID == 1 ||
          lstArrInvoice[0].nStatusID == 3 ||
          lstArrInvoice[0].nStatusID == 5 ||
          lstArrInvoice[0].nStatusID == 7 ||
          lstArrInvoice[0].nStatusID == 10
        ) {
          let chunks = lstArrInvoice[0].dPostingDate.split("/");
          this.toDay =
            lstArrInvoice[0].dRequestDate == null
              ? this.BusinessDay.SetToday(this.holidays)
              : new Date(lstArrInvoice[0].dRequestDate);
          let dPostingDate = new Date(
            chunks[1] + "-" + chunks[0] + "-" + chunks[2]
          );

          if (
            (lstArrInvoice[0].nStatusID == 1 ||
              lstArrInvoice[0].nStatusID == 3 ||
              lstArrInvoice[0].nStatusID == 5 ||
              lstArrInvoice[0].nStatusID == 7 ||
              lstArrInvoice[0].nStatusID == 10) &&
            dPostingDate < _this.Settodate
          ) {
            this.maxDate.setDate(this.maxDate.getDate() + 1);
            this.TODAY = this.BusinessDay.SetNextDate(
              this.maxDate,
              this.holidays
            );
            let check_date = this.BusinessDay.setDueDatebyDate(
              this.Settodate,
              this.TODAY,
              this.holidays
            );
          }
          await _this.http
            .get(
              _this.System.SiteName +
                "api/_paytovendor/GetRequest/" +
                lstArrInvoice[0].sCopyReqID +
                ""
            )
            .toPromise()
            .then((data: any) => {
              if (data != null) {
                let Data = data.filter((f) => f.cActive != "N");
                _this.JVForm.patchValue({
                  sCopyRequest: Data[0].sRequestCode,
                });
              }
            });

          let isOntime: any;

          _this.isEditFromhome = true;
          let totalDr = 0;
          let totalCr = 0;
          let value = 0;
          _this.ArrInvoice.forEach(function (value, i) {
            _this.Currencys = value.sCurrency;
            _this.IsVendorOneTime = value.IsVendorOneTime;
            _this.isDraft =
              value.nStatusID == 1 ||
              value.nStatusID == 3 ||
              value.nStatusID == 5 ||
              value.nStatusID == 7 ||
              value.nStatusID == 10
                ? true
                : false;
            _this.isSubmit = value.nStatusID == 2 ? true : false;
            _this.isNew = true;
            _this.isPrint = true;
            _this.isThai = true;
            value.IsDelete = value.cActive == "N" ? true : false;
            if (value.cSkipApprove1 == "Y") {
              _this.JVForm.get("ddApprover1").disable();
            } else {
              _this.JVForm.get("ddApprover1").enable();
            }

            _this.JVForm.patchValue({
              nContactID: value.nContactID + "",
              sName: value.sName,
              sEmail: value.sEmail,
              sUnit: value.sUnit,
              sTel: value.sTel,
              ntype: value.ntype,
              dPostingDate: new Date(_this.convertTodate(value.dPostingDate)),
              nCopyRequest: value.sCo3pyReqID,
              sDescription: value.sDescription,
              sOtherRefNoFIDocNo: value.sOtherRefNoFIDocNo,
              sRequestID: value.sRequestID,
              ddApprover1: value.sUserApprove1,
              ddApprover2: value.sUserApprove2,
              sApprove1: value.nApprove1 == null ? null : value.nApprove1,
              sApprove2: value.nApprove2 == null ? null : value.nApprove2,
              cSkipApprove1: value.cSkipApprove1 == "Y" ? true : false,
              ddCurrency: value.sCurrency,
              sComment: value.sComment,
              sCommentSSC: value.sCommentSSC,
              IsUploadExcelFile: value.IsUploadExcelFile
                ? value.IsUploadExcelFile
                : false,
            });
            _this.sComment = value.sComment;
            _this.sCommentSSC = value.sCommentSSC;
            if (value.nLine != null) {
              _this.ArrGL.push(
                new FormGroup({
                  sGL: new FormControl(value.sGL, Validators.required),
                  sCostCenter: new FormControl(value.sCostCenter),
                  sIO: new FormControl(value.sIO),
                  sProfitCenter: new FormControl(value.sProfitCenter),
                  sAmountExcludedVAT: new FormControl(
                    value.sAmount.toFixed(2),
                    Validators.required
                  ),
                  sText: new FormControl(value.sText, Validators.required),
                  IsDelete: new FormControl(value.IsDelete),
                  sInvoiceNo: new FormControl(
                    value.IsUploadExcelFile ? value.nItemNo.toString() : ""
                  ),
                  nline: new FormControl(value.nLine),
                  nReceiveType: new FormControl(value.nReceiveType.toString()),
                })
              );
            }
            if (value.cActive === "Y") {
              if (value.nReceiveType === 1) {
                totalDr += value.sAmount;
              } else {
                totalCr += value.sAmount;
              }
            }
          });
          if (this.JVForm.get("IsUploadExcelFile").value == true) {
            let data: any;
            let data2: any;
            await this.http
              .get(
                this.System.SiteName +
                  "api/_Paytovendor/GetRequestExcelJV/" +
                  sReqID +
                  ""
              )
              .toPromise()
              .then((Data) => (data = Data));

            for (var i = 0; i < data.length; i++) {
              let chunks = data[i].sPostingDate.split("/");
              var newDate = new Date(chunks[2], chunks[1] - 1, chunks[0]);
              data[i].sPostingDate = newDate;
            }
            _this.arrExcel = data;
          }
          this.totalDr = this._ConvertToDecimal(totalDr);
          this.totalCr = this._ConvertToDecimal(totalCr);
        }
        //_this.ArrGL.push(new FormGroup({
        //  sGL: new FormControl('', Validators.required),
        //  sCostCenter: new FormControl(''),
        //  sIO: new FormControl('', Validators.required),
        //  sProfitCenter: new FormControl(''),
        //  sAmountExcludedVAT: new FormControl('', Validators.required),
        //  sText: new FormControl('', Validators.required),
        //  IsDelete: new FormControl(''),
        //  sInvoiceNo: new FormControl(''),
        //  nline: new FormControl(''),
        //  nReceiveType: new FormControl('1')
        //}))
        //this.checkUseIo();
        //this.checkUseGL();
        this.System.UnBlockUI();
      } else {
        this.ArrMaster = [];
        this.ArrMaster.push(this.ArrIO);
        this.ArrGL.clear();
        this.Currencys = "THB";

        this._JVForm.ArrGL.reset();
        _this.ArrGL.push(
          new FormGroup({
            sGL: new FormControl("", Validators.required),
            sCostCenter: new FormControl(""),
            sIO: new FormControl("", Validators.required),
            sProfitCenter: new FormControl(""),
            sAmountExcludedVAT: new FormControl("", Validators.required),
            sText: new FormControl("", Validators.required),
            IsDelete: new FormControl(false),
            sInvoiceNo: new FormControl(""),
            nline: new FormControl(""),
            nReceiveType: new FormControl("1"),
          })
        );
        _this.isNew = true;
        _this.ArrInvoice = [];
        this.checkUseIo();
        this.checkUseGL();
        let data: any;
        await this.http
          .get(
            this.System.SiteName +
              "api/_Paytovendor/GetRequestNoItem/" +
              sReqID +
              ""
          )
          .toPromise()
          .then((Data) => (data = Data));
        if (data != null) {
          let chunks = data[0].dPostingDate.split("/");
          this.toDay =
            data[0].dRequestDate == null
              ? this.BusinessDay.SetToday(this.holidays)
              : new Date(data[0].dRequestDate);
          let dPostingDate = new Date(
            chunks[1] + "-" + chunks[0] + "-" + chunks[2]
          );
          let check_date = this.BusinessDay.setDueDatebyDate(
            this.Settodate,
            dPostingDate,
            this.holidays
          );
          if (
            (data[0].nStatusID == 1 ||
              data[0].nStatusID == 3 ||
              data[0].nStatusID == 5 ||
              data[0].nStatusID == 7 ||
              data[0].nStatusID == 10) &&
            dPostingDate < _this.Settodate
          ) {
            this.maxDate.setDate(this.maxDate.getDate() + 1);
            this.TODAY = this.BusinessDay.SetNextDate(
              this.maxDate,
              this.holidays
            );
            let check_date = this.BusinessDay.setDueDatebyDate(
              this.Settodate,
              this.TODAY,
              this.holidays
            );
          }
          if (data[0].cSkipApprove1 == "Y") {
            _this.JVForm.get("ddApprover1").disable();
          } else {
            _this.JVForm.get("ddApprover1").enable();
          }
          _this.JVForm.patchValue({
            dPostingDate: dPostingDate,
            nContactID: data[0].nContactID + "",
            sName: data[0].sName,
            sEmail: data[0].sEmail,
            sUnit: data[0].sUnit,
            sTel: data[0].sTel,
            ntype: data[0].ntype,

            sRequestID: data[0].sRequestID,
            ddApprover1: data[0].sUserApprove1,
            ddApprover2: data[0].sUserApprove2,
            sApprove1: data[0].nApprove1 == null ? null : data[0].nApprove1,
            sApprove2: data[0].nApprove2 == null ? null : data[0].nApprove2,
            cSkipApprove1: data[0].cSkipApprove1 == "Y" ? true : false,
          });
        }
        this.System.UnBlockUI();
      }
    } else {
      this.Currencys = "THB";
      if (!this.isNewRequest) {
        let data: any;
        await _this.http
          .get(
            _this.System.SiteName + "api/ROService/GetRequest/" + sReqID + ""
          )
          .toPromise()
          .then((Data) => (data = Data));
        if (data != null) {
          _this.JVForm.patchValue({
            sRequestID: data[0].sRequestID,
            ntype: data[0].nReqType.toString(),
            sComment: data[0].sComment,
            sCommentSSC: `Expected Complete Date : ${data[0].dExpectedCompleteDate}${data[0].sRemarkSSC ? `\n${data[0].sRemarkSSC}` : ''}`,
          });
          _this.sComment = data[0].sComment;
          _this.sCommentSSC = data[0].sRemarkSSC;
          _this.onUserSelect(data[0].sFullName);
        }
      }
    }

    if (!this.isNewRequest) {
      let file: any;
      await this.http
        .get(this.System.SiteName + "api/_Paytovendor/Getfile/" + sReqID + "")
        .toPromise()
        .then((Data) => (file = Data));
      if (file) {
        let arrdata = [];
        if (file.length != 0) {
          file.forEach((f) =>
            arrdata.push({
              nID: f.nFileOrder,
              sPath: f.sPathFile,
              sSystemFileName: f.sSystemFileName,
              sFileName: f.sFileName,
              sSize: +f.sFileSize,
            })
          );
          SetData("dvFile", arrdata);
        }
      }
    }

    //Check Permission
    let ObjData = {
      sRequestID: sReqID,
      nMenuID: 10,
    };
    let isio = await this.System.GetCompanyUSEIO(ObjData);
    if (isio != null) {
      _this.isUseIo = isio;
      _this.IsNotFill_IO = isio;
      _this.checkUseIo();
    }
    let isGL = await this.System.GetCompanyUSEGL(ObjData);
    if (isGL != null) {
      _this.isUseGL = isGL;
      _this.IsNotFill_GL = isGL;
      _this.checkUseGL();
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (!this.ResultPermission) {
      this.JVForm.disable();
      this.JVForm.get("sCompName").enable();
    }
    this.System.UnBlockUI();
  }

  //*****************************************
  OnBlurGCI(event: TypeaheadMatch, _inx, _sType) {
    let FromArray = this.JVForm.get("ArrGL") as FormArray;
    let Pass: boolean = true;
    try {
      switch (_sType) {
        case "G":
          if (!event.item.GL_ACCOUNT_NO) {
            Pass = false;
          }
          break;
        case "C":
          let stC = this.ArrGL.at(_inx).get("sCostCenter").value;
          let ischeckC = this.ArrCostCenter.filter(
            (f) => f.COST_CENTER == stC || f.name == stC || f.DESCRIPTION == stC
          )[0];
          if (isNullOrUndefined(ischeckC)) {
            Pass = false;
          }
          break;
        case "I":
          let stI = this.ArrGL.at(_inx).get("sIO").value;
          let ischeckI = this.ArrMaster[_inx].filter(
            (f) =>
              f.ORDER_NUMBER == stI || f.name == stI || f.DESCRIPTION == stI
          )[0];
          if (isNullOrUndefined(ischeckI)) {
            Pass = false;
          }
          break;
        case "P":
          let stP = this.ArrGL.at(_inx).get("sProfitCenter").value;
          let ischeckP = this.ArrProfitCenter.filter(
            (f) =>
              f.sProfitCenterNo == stP || f.name == stP || f.DESCRIPTION == stP
          )[0];
          if (isNullOrUndefined(ischeckP)) {
            Pass = false;
          }
          break;
      }
    } catch (ex) {
      //กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      this.OnSelectGCI(event, _inx, _sType);
    } else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
        case "P":
          FromArray.at(_inx).patchValue({ sProfitCenter: "" });
          break;
      }
    }
  }
  OnSelectGCI(event, _inx, _sType) {
    let FromArray = this.JVForm.get("ArrGL") as FormArray;
    switch (_sType) {
      case "G":
        FromArray.at(_inx).patchValue({ sGL: event.item.GL_ACCOUNT_NO });
        break;
      case "C":
        this.ArrMaster[_inx] = this.ArrIO;
        FromArray.at(_inx).patchValue({ sCostCenter: event.item.COST_CENTER });
        break;
      case "I":
        FromArray.at(_inx).patchValue({ sIO: event.item.ORDER_NUMBER });
        break;
      case "P":
        FromArray.at(_inx).patchValue({
          sProfitCenter: event.item.sProfitCenterNo,
        });
        break;
    }
  }

  AddGL() {
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.push(
      new FormGroup({
        sGL: new FormControl("", Validators.required),
        sCostCenter: new FormControl(""),
        sIO: new FormControl(""),
        sProfitCenter: new FormControl(""),
        sAmountExcludedVAT: new FormControl("", Validators.required),
        sText: new FormControl("", Validators.required),
        IsDelete: new FormControl(false),
        sInvoiceNo: new FormControl(""),
        nReceiveType: new FormControl("1"),
      })
    );
    this.checkUseIo();
  }
  DeleteGL(sInvoiceNo, row) {
    let _this = this;

    this.SW.SwAlert.Confirm(
      this.SW.BoxMsg.Title_Confirm,
      this.SW.BoxMsg.Desc_Confirm_Delete,
      function () {
        _this.ArrGL.at(row).patchValue({ IsDelete: true });
        _this.ArrGL.at(row).get("sGL").markAsUntouched({ onlySelf: true });
        _this.ArrGL.at(row).get("sGL").setValidators(null);
        _this.ArrGL.at(row).get("sGL").setErrors(null);
        _this.ArrGL.at(row).get("sGL").clearValidators();
        _this.ArrGL.at(row).get("sGL").updateValueAndValidity();

        _this.ArrGL.at(row)
          .get("sAmountExcludedVAT")
          .markAsUntouched({ onlySelf: true });
        _this.ArrGL.at(row).get("sAmountExcludedVAT").setValidators(null);
        _this.ArrGL.at(row).get("sAmountExcludedVAT").setErrors(null);
        _this.ArrGL.at(row).get("sAmountExcludedVAT").clearValidators();
        _this.ArrGL.at(row).get("sAmountExcludedVAT").updateValueAndValidity();

        _this.ArrGL.at(row).get("sText").markAsUntouched({ onlySelf: true });
        _this.ArrGL.at(row).get("sText").setValidators(null);
        _this.ArrGL.at(row).get("sText").setErrors(null);
        _this.ArrGL.at(row).get("sText").clearValidators();
        _this.ArrGL.at(row).get("sText").updateValueAndValidity();

        _this.calculateTotal();
      },
      function () {}
    );
  }
  OnSkipApprove1() {
    let _this = this;
    if (_this.JVForm.value["cSkipApprove1"]) {
      _this.JVForm.patchValue({ sApprove1: null });
      _this.JVForm.get("ddApprover1").reset();
      _this.JVForm.get("ddApprover1").disable();
    } else {
      let name1 = _this.DataApprover.filter(
        (f) => f.nUserID == _this.GetApprover.name1ID
      )[0];
      let nUserId = _this.DataApprover.filter(
        (f) => f.nUserID == _this.GetApprover.name1ID
      )[0];
      this.JVForm.patchValue({
        ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
        sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
      });
      this.JVForm.get("ddApprover1").enable();
    }
  }
  Export() {
    const link = document.createElement("a");
    link.target = "_blank";
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.sReqID + "")
        .set("nContactID", this.JVForm.get("nContactID").value),
    };
    link.href =
      this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params;
    link.setAttribute("visibility", "hidden");
    link.click();
  }

  onDownloadTemplate() {
    let sendData = JSON.stringify({});
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    this.http
      .post(
        this.System.SiteName + "api/_Paytovendor/DownloadTemplate?sReqID=JV",
        sendData,
        { headers, responseType: "arraybuffer" }
      )
      .subscribe((res) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        this.save(blob, "JV_Template.xlsx");
      });
  }

  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) {
      // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else {
      // For other browsers:
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }

  Back() {
    this.router.navigate(["/home"]);
  }
  SetForm() {
    let ua = this.System.GetUserStorage();
    this.JVForm = this.formBuilder.group({
      sRequestID: [null],
      sRequestBy: [ua.nUserID],
      nContactID: [ua.nUserID],
      sName: [ua.sFullName, Validators.required],

      sEmail: [
        ua.sEmail,
        Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$"),
      ],
      sUnit: [ua.sUnitName],
      sTel: [ua.sTel],
      dToday: [this.dToday],
      sCompCode: [ua.sCompCode],
      sCompName: [ua.sCompName],
      sBusinessArea: [null],

      ntype: ["80"],
      dPostingDate: [null, Validators.required],
      sCopyRequest: [null],
      nCopyRequest: [null],
      sOtherRefNoFIDocNo: [null],
      sDescription: [null, Validators.required],
      ddCurrency: ["THB"],
      sComment: [null],
      sCommentSSC: [null],
      IsUploadExcelFile: [false],
      nTotalDr: [null, Validators.required],
      nTotalCr: [null, Validators.required],
      ArrGL: new FormArray([
        new FormGroup({
          sGL: new FormControl("", Validators.required),
          sCostCenter: new FormControl(""),
          sIO: new FormControl(""),
          sProfitCenter: new FormControl(""),
          sAmountExcludedVAT: new FormControl("", Validators.required),
          sText: new FormControl("", Validators.required),
          IsDelete: new FormControl(false),
          sInvoiceNo: new FormControl(""),
          nline: new FormControl(""),
          nReceiveType: new FormControl("1"),
        }),
      ]),

      ddApprover1: [null, Validators.required],
      sApprove1: [null],
      sApprove2: [null],
      ddApprover2: [null, Validators.required],
      cSkipApprove1: [null],
    });
  }

  setReceiveType(index, type) {
    let FromArray = this.JVForm.get("ArrGL") as FormArray;
    FromArray.at(index).patchValue({ nReceiveType: type });
    this.calculateTotal();
  }

  onChangeCurrency(value) {
    this.Currencys = value;
  }

  OnUploadExcelFile() {
    let _thisOther = this;
    _thisOther.ArrGL.clear();
    _thisOther.ArrInvoice = [];
    _thisOther.arrExcel = [];
    _thisOther.fileName = "";
    _thisOther.fileDetail = null;
    _thisOther.ExcelData = null;
    if (this.JVForm.get("IsUploadExcelFile").value == false) {
      _thisOther.AddGL();
    }
  }

  calculateTotal() {
    let FromArray = this.ArrGL.value.filter((x) => x.IsDelete == false);
    let totalDr = 0;
    let totalCr = 0;
    for (let i = 0; i < FromArray.length; i++) {
      let value = 0;
      let str = FromArray[i].sAmountExcludedVAT;
      let type = FromArray[i].nReceiveType;
      if (Number.isInteger(str)) {
        value = str;
      } else {
        if (str === "") {
          str = "0";
        } else if (str.substring(str.length - 1) === ".") {
          str = str.substring(0, str.length - 1);
        }
        value = parseFloat(str);
      }
      if (type === "1") {
        totalDr += value;
      } else {
        totalCr += value;
      }
    }
    this.totalDr = this._ConvertToDecimal(totalDr);
    this.totalCr = this._ConvertToDecimal(totalCr);
  }

  getReqID() {
    let comcode = this.nComcode;
    let width = comcode.toString().length;
    if (width > 0) {
      comcode = new Array(width == 3 ? 0 : 3).join("0") + comcode;
    }
    let dToday = this.datepipe.transform(this.today, "yyMMdd");
    let type = this.JVForm.value.ntype;
    let ReqID: string = comcode + dToday + type;
    return ReqID;
  }

  //#region Validate
  isFieldValid(_Field: string) {
    return !this.JVForm.get(_Field).valid && this.JVForm.get(_Field).touched;
  }
  displayFieldCss(_Field: string) {
    return {
      "has-error": this.isFieldValid(_Field),
      "has-feedback": this.isFieldValid(_Field),
    };
  }
  isFieldValidTbGl(_Field: string, _inx) {
    let FromArray = this.JVForm.get("ArrGL") as FormArray;
    return (
      !FromArray.at(_inx).get(_Field).valid &&
      FromArray.at(_inx).get(_Field).touched
    );
  }
  displayFieldCssTbGl(_Field: string, _inx) {
    return {
      "has-error": this.isFieldValidTbGl(_Field, _inx),
      "has-feedback": this.isFieldValidTbGl(_Field, _inx),
    };
  }

  convertTodate(dDate) {
    let chunks = dDate.split("/");
    return new Date(chunks[1] + "-" + chunks[0] + "-" + chunks[2]);
  }
  _ConvertToDecimal(sVal) {
    let NoComma = (sVal + "").replace(/,/g, ""); //ตัด Comma ออก
    let Data = this._decimalPipe.transform(NoComma, "1.2-2");
    return Data;
  }

  CopyNoResults(event: boolean): void {
    this.CopyNoResult = event;
  }
  CopyOnBlur(item) {
    let sCopyRequest = this.JVForm.get("sCopyRequest").value;
    let ischeck = this.DataRequest.filter(
      (user) => user.sRequestCode == sCopyRequest
    )[0];
    if (this.DataRequest) {
      if (sCopyRequest == "") {
      } else if (
        sCopyRequest != "" &&
        this.CopyNoResult == false &&
        !isNullOrUndefined(ischeck)
      ) {
        this.onCopyRequestCodeSelect(item);
      }
      if (this.CopyNoResult == true) {
        this.JVForm.patchValue({
          sCopyRequest: null,
          nCopyRequest: null,
        });
      } else if (this.CopyNoResult == false && isNullOrUndefined(ischeck)) {
        this.JVForm.patchValue({
          sCopyRequest: null,
          nCopyRequest: null,
        });
      }
    }
  }

  GlNoResults(event: boolean, index): void {
    this.GlNoResult[index] = event;
  }
  GlOnBlur(event, index) {
    if (this.GlNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sGL: null });
    }
  }
  CostCenterNoResults(event: boolean, index): void {
    this.CostCenterNoResult[index] = event;
  }
  CostCenterOnBlur(event, index) {
    if (this.CostCenterNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sCostCenter: null });
    }
  }
  IONoResults(event: boolean, index): void {
    this.IONoResult[index] = event;
  }
  IOOnBlur(event, index) {
    if (this.IONoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sIO: null });
    }
  }
  ProfitCenterNoResults(event: boolean, index): void {
    this.ProfitCenterNoResult[index] = event;
  }
  ProfitCenterOnBlur(event, index) {
    if (this.ProfitCenterNoResult[index] == true) {
      this.ArrGL.at(index).patchValue({ sProfitCenter: null });
    }
  }
  Approver2NoResults(event: boolean): void {
    this.Approve2NoResult = event;
  }
  Approver1NoResults(event: boolean): void {
    this.Approve1NoResult = event;
  }
  //

  checkUseIo() {
    let _this = this;
    if (this.isUseIo) {
      _this.IsNotFill_IO = false;
      _this.ArrGL.controls.forEach(function (row) {
        row.get("sIO").enable();
      });
    } else {
      _this.IsNotFill_IO = true;
      _this.ArrGL.controls.forEach(function (row) {
        row.get("sIO").disable();
      });
    }
  }
  checkUseGL() {
    let _this = this;
    if (this.isUseGL) {
      _this.IsNotFill_GL = false;
      _this.ArrGL.controls.forEach(function (row) {
        row.get("sGL").enable();
      });
    } else {
      _this.IsNotFill_GL = true;
      _this.ArrGL.controls.forEach(function (row) {
        row.get("sGL").disable();
      });
    }
  }
  Check2Digit(sValue) {
    let Result: number = 0;
    if (sValue) {
      let sValueNoComma = (sValue + "").replace(/,/g, "");
      let sValueNoComma2 = Math.round(parseFloat(sValueNoComma) * 100) / 100;
      Result = Number(sValueNoComma2.toFixed(2));
    }
    return Result;
  }
}
function _IsNullOrEmpty(str) {
  var Result = true;
  if (str && str != "null") {
    Result = false;
  }
  return Result;
}
function _ParseFloatToZero(sVal) {
  let Result: any = 0;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, ""); //ตัด Comma ออก
    Result = parseFloat(NoComma);
  }
  return Result;
}
function _ParseFloatToNull(sVal) {
  let Result: any = null;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, ""); //ตัด Comma ออก
    Result = parseFloat(NoComma);
  }
  return Result;
}
